/* Favoris GRENADINE : liste de produits (handles) gardee dans ce navigateur (localStorage "gr_favoris").
   - window.grFav.has(h) / toggle(h) / list()
   - Fiche produit : bouton .favorite-btn[data-fav-handle] (coeur rose = dans les favoris)
   - Page /pages/favoris : [data-gr-fav-page] affiche les produits */
(function () {
  var KEY = 'gr_favoris';
  var PINK = 'https://cdn.shopify.com/s/files/1/0729/3983/1631/files/favori_image_rose_grenadine.png?v=1747835482';
  var WHITE = 'https://cdn.shopify.com/s/files/1/0729/3983/1631/files/favori_image_grenadine.png?v=1747835462';
  function read() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
    document.querySelectorAll('[data-gr-fav-count-hdr]').forEach(function (b) { b.textContent = a.length; b.classList.toggle('hidden', !a.length); });
  }
  /* cliente connectee : la liste est aussi gardee sur son compte (relais GRENADINE -> metafield client custom.favoris)
     window.grFavAcc = {cid, em, sig} (snippet gr-cliente-sig) et window.grFavSaved = liste deja sur le compte */
  var RELAY = 'https://blue-darkness-90a5.oriana-mechiche.workers.dev/favoris';
  var acc = window.grFavAcc || null;
  var syncT = null;
  function push() {
    if (!acc) return;
    clearTimeout(syncT);
    syncT = setTimeout(function () {
      try { fetch(RELAY, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ cid: acc.cid, em: acc.em, sig: acc.sig, handles: read() }), keepalive: true }).catch(function () {}); } catch (e) {}
    }, 400);
  }
  if (acc) {
    /* on reunit toujours les favoris du compte et ceux de cet appareil (rien n'est perdu) */
    var saved = Array.isArray(window.grFavSaved) ? window.grFavSaved : [];
    var local = read(), merged = local.slice();
    saved.forEach(function (h) { if (merged.indexOf(h) === -1) merged.push(h); });
    write(merged);
    if (JSON.stringify(merged) !== JSON.stringify(saved)) push();
  }
  var api = {
    list: read,
    has: function (h) { return read().indexOf(h) !== -1; },
    toggle: function (h) { var a = read(), i = a.indexOf(h); if (i === -1) a.unshift(h); else a.splice(i, 1); write(a); push(); return i === -1; },
    remove: function (h) { write(read().filter(function (x) { return x !== h; })); push(); }
  };
  window.grFav = api;

  function toast(added) {
    var old = document.querySelector('.gr-fav-toast'); if (old) old.remove();
    var t = document.createElement('div'); t.className = 'gr-fav-toast'; t.setAttribute('role', 'status');
    t.innerHTML = added ? 'Ajouté à vos favoris 🩷 <a href="/pages/favoris">Voir mes favoris</a>' : 'Retiré de vos favoris';
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('is-on'); }, 10);
    setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 300); }, 3200);
  }
  function paint(btn) {
    var on = api.has(btn.getAttribute('data-fav-handle'));
    /* les deux coeurs de la fiche (photo ordi + photo telephone) restent synchronises */
    btn.classList.toggle('active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Retirer des favoris' : 'Ajouter aux favoris');
    var img = btn.querySelector('img'); if (img) img.src = on ? PINK : WHITE;
  }
  function initButtons() {
    document.querySelectorAll('.favorite-btn[data-fav-handle]').forEach(function (b) {
      if (b.__grFav) return; b.__grFav = true; paint(b);
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); var added = api.toggle(b.getAttribute('data-fav-handle')); document.querySelectorAll('.favorite-btn[data-fav-handle]').forEach(paint); toast(added); }, true);
      b.addEventListener('mouseleave', function () { paint(b); });
    });
  }

  function money(c) { try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(c / 100); } catch (e) { return (c / 100).toFixed(2) + ' €'; } }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function imgUrl(p) {
    var img = p.featured_image || ''; if (!img) return '';
    var sep = img.indexOf('?') === -1 ? '?' : '&';
    return img + sep + 'width=500' + (/\.svg(\?|$)/i.test(img) ? '&format=pjpg' : '');
  }
  function fetchAll(hs) {
    return Promise.all(hs.map(function (h) { return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }));
  }
  function card(p, gift) {
    var img = imgUrl(p);
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    return '<article class="grf-card"><a class="grf-img" href="/products/' + esc(p.handle) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="500" height="500">' : '') + '</a>' +
      (gift ? '' : '<button type="button" class="grf-x" data-gr-fav-rm="' + esc(p.handle) + '" aria-label="Retirer ' + esc(p.title) + ' des favoris"><img src="' + PINK + '" alt="" width="42" height="42"></button>') +
      '<a class="grf-info" href="/products/' + esc(p.handle) + '"><p class="grf-v">' + esc(p.vendor) + '</p><h2 class="grf-n">' + esc(p.title) + '</h2><p class="grf-p">' + (p.price_varies ? 'À partir de ' : '') + money(p.price_min) + (p.available ? '' : ' <span class="grf-out">Épuisé</span>') + '</p></a>' +
      (gift ? (v ? '<button type="button" class="grf-gift" data-gr-gift="' + v.id + '">Offrir 🎁</button>' : '<a class="grf-gift grf-gift--ghost" href="/products/' + esc(p.handle) + '">Voir le produit</a>') : '') +
      '</article>';
  }
  function initPage() {
    var root = document.querySelector('[data-gr-fav-page]'); if (!root) return;
    var grid = root.querySelector('[data-gr-fav-grid]'), empty = root.querySelector('[data-gr-fav-empty]'), count = root.querySelector('[data-gr-fav-count]');
    var share = root.querySelector('[data-gr-wish]');
    var qs = new URLSearchParams(location.search), shared = qs.get('liste');

    /* ---- la personne qui a recu le lien : "La liste de souhaits de ..." (ses propres favoris ne sont pas touches) ---- */
    if (shared !== null) {
      var who = (qs.get('de') || '').trim().slice(0, 40);
      who = who ? who.charAt(0).toUpperCase() + who.slice(1) : '';
      var hsS = shared.split(',').map(function (h) { return h.toLowerCase().trim(); }).filter(function (h) { return /^[a-z0-9][a-z0-9_-]{0,120}$/.test(h); }).slice(0, 60);
      root.classList.add('grf--gift');
      var t = root.querySelector('[data-gr-fav-title]');
      if (t) t.innerHTML = '<span class="grf-b">' + (who ? 'La liste ' + (/^[aeiouyhàâéèêëîïôûü]/i.test(who) ? 'd’' : 'de ') + esc(who) : 'Une liste de souhaits') + '</span><span class="grf-i">ce qui lui ferait plaisir 🎁</span>';
      var lb = root.querySelector('.grf-label'); if (lb) lb.textContent = 'Liste de souhaits';
      if (share) share.hidden = true;
      var motTxt = (qs.get('mot') || '').slice(0, 300), motEl = root.querySelector('[data-gr-mot]');
      if (motEl && motTxt) { motEl.textContent = '« ' + motTxt + ' »' + (who ? ' — ' + who : ''); motEl.hidden = false; }
      var note = root.querySelector('.grf-note'); if (note) note.innerHTML = 'Envie de lui faire plaisir ? Touchez « Offrir » : le produit s’ajoute à votre panier. Vous pouvez aussi le retirer au salon GRENADINE, Lyon 6.';
      fetchAll(hsS).then(function (ps) {
        var ok = ps.filter(Boolean);
        grid.innerHTML = ok.map(function (p) { return card(p, true); }).join('');
        if (count) count.textContent = ok.length + (ok.length > 1 ? ' produits' : ' produit');
        empty.hidden = ok.length > 0; grid.hidden = ok.length === 0;
        if (!ok.length) empty.querySelector('p').textContent = 'Cette liste est vide pour le moment.';
        /* barre fixe en bas : offrir toute la liste d'un coup (produits disponibles) */
        var avail = ok.map(function (p) { return (p.variants || []).filter(function (x) { return x.available; })[0]; }).filter(Boolean);
        if (avail.length > 1) {
          var tot = avail.reduce(function (s, v) { return s + v.price; }, 0);
          var bar = document.createElement('div'); bar.className = 'grf-all';
          bar.innerHTML = '<button type="button" class="grf-all-btn"><span>J’offre toute la liste</span><b>' + money(tot) + '</b></button>';
          document.body.appendChild(bar); document.body.classList.add('grf-has-all');
          var ab = bar.querySelector('button');
          ab.addEventListener('click', function () {
            ab.disabled = true; ab.querySelector('span').textContent = 'Ajout au panier…';
            fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: avail.map(function (v) { return { id: v.id, quantity: 1 }; }) }) })
              .then(function (r) {
                ab.querySelector('span').textContent = r.ok ? 'Toute la liste est dans le panier ✓' : 'Un produit n’est plus disponible';
                if (r.ok) { grid.querySelectorAll('[data-gr-gift]').forEach(function (b) { b.disabled = true; b.textContent = 'Dans le panier ✓'; }); if (window.grOpenCart) window.grOpenCart(); }
                else ab.disabled = false;
              })
              .catch(function () { ab.disabled = false; ab.querySelector('span').textContent = 'Réessayer'; });
          });
        }
      });
      grid.addEventListener('click', function (e) {
        var b = e.target.closest('[data-gr-gift]'); if (!b) return;
        b.disabled = true; b.textContent = 'Ajout…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-gr-gift'), quantity: 1 }] }) })
          .then(function (r) { b.textContent = r.ok ? 'Dans le panier ✓' : 'Indisponible'; if (r.ok && window.grOpenCart) window.grOpenCart(); })
          .catch(function () { b.textContent = 'Réessayer'; b.disabled = false; });
      });
      return;
    }

    /* ---- mes favoris ---- */
    var hs = api.list(), items = [];
    var openBtn = root.querySelector('[data-gr-wish-open]');
    function setCount(n) { if (count) count.textContent = n + (n > 1 ? ' produits' : ' produit'); empty.hidden = n > 0; grid.hidden = n === 0; if (share) share.hidden = n === 0; if (openBtn) openBtn.hidden = n === 0; }
    /* telephone : le bouton fixe en bas ouvre le partage en fenetre du bas */
    if (openBtn && share) {
      var ov = root.querySelector('[data-gr-wish-ov]');
      function sheet(on) { share.classList.toggle('is-open', on); if (ov) ov.classList.toggle('is-on', on); openBtn.hidden = on || api.list().length === 0; }
      openBtn.addEventListener('click', function () { sheet(true); });
      if (ov) ov.addEventListener('click', function () { sheet(false); });
      share.addEventListener('click', function (e) { if (e.target.closest('[data-gr-wish-close]')) sheet(false); });
    }
    setCount(hs.length);
    if (!hs.length) return;
    fetchAll(hs).then(function (ps) {
      items = ps.filter(Boolean);
      hs.forEach(function (h, i) { if (!ps[i]) api.remove(h); });
      grid.innerHTML = items.map(function (p) { return card(p, false); }).join('');
      setCount(items.length);
      /* "Je m'offre tout ca moi-meme" : tous les favoris disponibles dans le panier d'un coup */
      var self = root.querySelector('[data-gr-self]');
      function paintSelf() {
        if (!self) return;
        var av = items.map(function (p) { return (p.variants || []).filter(function (x) { return x.available; })[0]; }).filter(Boolean);
        self.hidden = !av.length;
        var tot = av.reduce(function (s, v) { return s + v.price; }, 0);
        self.querySelector('[data-gr-self-total]').textContent = money(tot);
        var off = items.length - av.length, s = self.querySelector('[data-gr-self-s]');
        s.textContent = off > 0 ? (off > 1 ? off + ' produits épuisés ne sont pas inclus.' : '1 produit épuisé n’est pas inclus.') : '';
        return av;
      }
      paintSelf();
      if (self) self.querySelector('[data-gr-self-btn]').addEventListener('click', function () {
        var b = this, av = paintSelf(); if (!av || !av.length) return;
        b.disabled = true; b.querySelector('span').textContent = 'Ajout au panier…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: av.map(function (v) { return { id: v.id, quantity: 1 }; }) }) })
          .then(function (r) { b.querySelector('span').textContent = r.ok ? 'Tout est dans votre panier ✓' : 'Un produit n’est plus disponible'; b.disabled = r.ok; if (r.ok && window.grOpenCart) window.grOpenCart(); })
          .catch(function () { b.disabled = false; b.querySelector('span').textContent = 'Réessayer'; });
      });
      grid.addEventListener('click', function (e) {
        var b = e.target.closest('[data-gr-fav-rm]'); if (!b) return;
        var h = b.getAttribute('data-gr-fav-rm'); api.remove(h); items = items.filter(function (p) { return p.handle !== h; });
        var c = b.closest('.grf-card'); if (c) c.remove(); setCount(api.list().length); if (typeof paintSelf === 'function') paintSelf();
      });
    });

    /* ---- partager ma liste : formulaire (occasion, prenom + e-mail du proche, petit mot) -> e-mail avec le lien ---- */
    if (!share) return;
    var me = share.getAttribute('data-gr-wish-name') || '';
    var form = share.querySelector('[data-gr-wish-form]'), mot = share.querySelector('[data-gr-wish-mot]'), err = share.querySelector('[data-gr-wish-err]');
    var MOTS = { noel: 'Voici ce qui me ferait plaisir pour Noël 🎄', anniv: 'Voici ce qui me ferait plaisir pour mon anniversaire 🎂', love: 'Mon amour, voici ce qui me ferait plaisir 🩷', mariage: 'Voici ma liste de cadeaux pour le mariage / l’EVJF 💍', envie: 'Voici les produits GRENADINE qui me font envie 🩷' };
    var SUBJ = { noel: 'Ma liste au Père Noël 🎄', anniv: 'Ma liste d’anniversaire 🎂', love: 'Ce qui me ferait plaisir 💌', mariage: 'Ma liste mariage / EVJF 💍', envie: 'Mes envies GRENADINE 🩷' };
    var motTouched = false;
    if (mot) mot.addEventListener('input', function () { motTouched = true; });
    form.addEventListener('change', function (e) { if (e.target.name === 'occ' && !motTouched && mot) mot.value = MOTS[e.target.value] || ''; });
    function link() {
      var m = mot ? mot.value.trim().slice(0, 300) : '';
      return location.origin + '/pages/favoris?liste=' + api.list().join(',') + (me ? '&de=' + encodeURIComponent(me) : '') + (m ? '&mot=' + encodeURIComponent(m) : '');
    }
    function lines() { return items.map(function (p) { return '• ' + p.title + ' (' + p.vendor + ') : ' + (p.price_varies ? 'à partir de ' : '') + money(p.price_min); }).join('\n'); }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var to = (form.to_email.value || '').trim(), name = (form.to_name.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(to)) { err.hidden = false; form.to_email.focus(); return; }
      err.hidden = true;
      var occF = form.querySelector('[name=occ]'), occ = (occF && (occF.tagName === 'SELECT' ? occF.value : (form.querySelector('[name=occ]:checked') || {}).value)) || 'envie';
      var m = mot ? mot.value.trim() : '';
      var body = (name ? 'Coucou ' + name + ',\n\n' : 'Coucou,\n\n') + (m ? m + '\n\n' : '') + lines() +
        '\n\nTu peux voir ma liste et m’offrir un produit en un clic ici :\n' + link() + '\n\n' + (me ? me + ' 🩷' : '🩷');
      location.href = 'mailto:' + encodeURIComponent(to) + '?subject=' + encodeURIComponent(SUBJ[occ] || SUBJ.envie) + '&body=' + encodeURIComponent(body);
    });
    share.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gr-wish-btn="copy"]'); if (!b) return;
      var u = link(), o = b.innerHTML, done = function () { b.textContent = 'Lien copié ✓'; setTimeout(function () { b.innerHTML = o; }, 2000); };
      if (navigator.clipboard) navigator.clipboard.writeText(u).then(done, function () { prompt('Copiez ce lien :', u); });
      else prompt('Copiez ce lien :', u);
    });
  }
  function go() { initButtons(); initPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
